import { render, staticRenderFns } from "./MyCourseTag.vue?vue&type=template&id=40d3354e&scoped=true"
import script from "./MyCourseTag.vue?vue&type=script&lang=js"
export * from "./MyCourseTag.vue?vue&type=script&lang=js"
import style0 from "./MyCourseTag.vue?vue&type=style&index=0&id=40d3354e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d3354e",
  null
  
)

export default component.exports